import { useMatch } from 'react-router-dom';
import { ROUTES } from '../router';

export function useIsPersonUpdatesPage() {
  const isProfileUpdateTab = !!useMatch(ROUTES.peopleUpdatesProfile);
  const isContactUpdateTab = !!useMatch(ROUTES.peopleUpdatesContact);
  const isAnalysisUpdateTab = !!useMatch(ROUTES.peopleUpdatesAnalysis);

  return isProfileUpdateTab || isContactUpdateTab || isAnalysisUpdateTab;
}
